import { FALLBACK_BASE_DOMAIN } from '../config/constants';

const deriveBaseUrl = (domain: string): string => {
  /**
   * ^([^.]+) — Captures the first part (up to the first dot).
   * \. — Matches the dot separating the first element from the rest.
   * (.+\..+)$ — Captures the rest, ensuring there are at least one dot.
   */
  const match = /^([^.]+)\.(.+\..+)$/.exec(domain) || [];
  if (match[2]) {
    return match[2];
  }

  return FALLBACK_BASE_DOMAIN;
};

export default deriveBaseUrl;
